module.exports = __webpack_public_path__ + "static/media/eth.d93c1cc4.svg";